export default __webpack_public_path__ + "static/media/mern.380df78d.jpg";